import {AuthTokenInterface} from './utils/auth';

export type TransformationSavePayload = {
    transform: string;
    cdnUrl: string;
};

const MessageTypeMap = {
    'PerceptPixel.ping': undefined as unknown as string,
    'PerceptPixel.pong': undefined as unknown as string,

    'PerceptPixel.success': undefined as unknown as string,
    'PerceptPixel.error': undefined as unknown as string,

    'PerceptPixel.auth': undefined as unknown as AuthTokenInterface,
    'PerceptPixel.Transformation.Save': undefined as unknown as TransformationSavePayload,
};

export type MessageType = keyof typeof MessageTypeMap;
export type PayloadType<T extends MessageType> = (typeof MessageTypeMap)[T];

export const parseMessage = <T extends MessageType>(e: MessageEvent, type: T): PayloadType<T> => {
    if (e.data.type !== type) {
        throw new Error(`invalid message type: ${e.data.type}`);
    }
    return e.data.payload as PayloadType<T>;
};

export const sendMessage = <T extends MessageType>(type: T, payload: PayloadType<T>, target: Window) => {
    target.postMessage({type, payload}, '*');
};
